/**
 * iter103 — Catalogo widget/sezioni della dashboard admin.
 * Il super-admin può nascondere alcuni di questi per ogni admin.
 * Le chiavi devono combaciare con il gating in AdminDashboard.js.
 */
export const DASHBOARD_WIDGETS = [
  { key: 'credito_totale', label: 'Credito totale aperto' },
  { key: 'stats', label: 'Statistiche rapide (3 card)' },
  { key: 'riepilogo_finanziario', label: 'Riepilogo finanziario' },
  { key: 'fatture_ricevute', label: 'Fatture ricevute' },
  { key: 'conti_emessi_kpi', label: 'Conti emessi (KPI)' },
  { key: 'promemoria_conti', label: 'Promemoria Conti' },
  { key: 'agenda', label: 'Agenda / Calendario' },
  { key: 'grafici', label: 'Grafici mensili' },
  { key: 'trend_clienti', label: 'Trend clienti' },
  { key: 'redditivita', label: 'Redditività cantieri' },
  { key: 'entrate_uscite', label: 'Entrate/Uscite e Scadenze' },
  { key: 'anni_precedenti', label: 'Anni precedenti' },
];
